import { CardInputStatus } from 'components/CreditCardInput/CreditCardInputField';

export type State = {
  inputValid: boolean;
  errorMessage?: string | null;
  sourceId?: string | null;
  stripeCallStatus: null | 'start' | 'processing' | 'done';
};

export const initialState = {
  inputValid: false,
  errorMessage: null,
  sourceId: null,
  stripeCallStatus: null,
};

/* ======= */
/* REDUCER */
/* ======= */

export default function reducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case 'creditCards/HANDLE_INPUT_CHANGE': {
      return { ...state, inputValid: action.cardValid, errorMessage: action.errorMessage };
    }
    case 'creditCards/SET_STRIPE_CALL_STATUS': {
      return { ...state, stripeCallStatus: action.status };
    }
    case 'creditCards/HANDLE_STRIPE_RESPONSE': {
      return {
        ...state,
        sourceId: action.sourceId,
        errorMessage: action.errorMessage,
        stripeCallStatus: 'done',
      };
    }
    case 'creditCards/RESET_FROM_ERROR': {
      return {
        ...initialState,
        errorMessage: action.errorMessage,
      };
    }
    case 'creditCards/REINITIALIZE': {
      return { ...initialState };
    }
    default:
      return state;
  }
}

/* ======= */
/* ACTIONS */
/* ======= */

export type ReinitializeAction = { type: 'creditCards/REINITIALIZE' };
export function reinitialize(): ReinitializeAction {
  return { type: 'creditCards/REINITIALIZE' };
}

// update state when user typing card data
export type HandleInputChange = {
  type: 'creditCards/HANDLE_INPUT_CHANGE';
  cardValid: boolean;
  errorMessage?: string | null;
};
export function handleInputChange(status: CardInputStatus): HandleInputChange {
  return {
    type: 'creditCards/HANDLE_INPUT_CHANGE',
    ...status,
  };
}

export type SetStripeCallStatus = {
  type: 'creditCards/SET_STRIPE_CALL_STATUS';
  status: string;
};
export function setStripeCallStatus(status: string): SetStripeCallStatus {
  return {
    type: 'creditCards/SET_STRIPE_CALL_STATUS',
    status,
  };
}

export type HandleStripeResponse = {
  type: 'creditCards/HANDLE_STRIPE_RESPONSE';
  sourceId?: string | null;
  errorMessage?: string | null;
};

export function handleStripeResponse(
  sourceId?: string | null,
  errorMessage?: string | null
): HandleStripeResponse {
  return {
    type: 'creditCards/HANDLE_STRIPE_RESPONSE',
    sourceId,
    errorMessage,
  };
}

export type ResetFromError = {
  type: 'creditCards/RESET_FROM_ERROR';
  errorMessage: string;
};

export function resetFromError(errorMessage: string): ResetFromError {
  return {
    type: 'creditCards/RESET_FROM_ERROR',
    errorMessage,
  };
}
